import React from 'react';
import { Card, Avatar, Tag, Space, Typography } from 'antd';
import { 
  UserOutlined, 
  CalendarOutlined, 
  EyeOutlined, 
  LikeOutlined,
  TagOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.css';

const { Text } = Typography;

const PostCard = ({ post, showAuthor = true }) => {
  const getCoverImage = (category) => {
    const images = {
      '技术': 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=400&h-200&fit=crop',
      '生活': 'https://images.unsplash.com/photo-1519677100203-5f3a2d3335c7?w=400&h=200&fit=crop',
      '旅行': 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=400&h=200&fit=crop',
      '美食': 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&h=200&fit=crop'
    };
    return images[category] || 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=400&h=200&fit=crop';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <Card
      className="post-card"
      cover={
        <div className="card-cover">
          <img 
            src={getCoverImage(post.category)} 
            alt={post.title}
          />
          <Tag color="blue" className="category-badge">
            {post.category}
          </Tag>
        </div>
      }
    >
      <div className="card-content">
        <Link to={`/post/${post.id}`}>
          <h3 className="post-title">{post.title}</h3>
        </Link>
        
        <div className="post-summary">{post.summary}</div>
        
        <div className="post-tags">
          {post.tags.map(tag => (
            <Tag key={tag} icon={<TagOutlined />} color="processing">
              {tag}
            </Tag>
          ))}
        </div>
        
        <div className="post-meta">
          {showAuthor && (
            <div className="author-info">
              <Avatar 
                className="author-avatar"
                size="small" 
                src={post.author === 'admin' ? 
                  'https://tu.tuhenmei.com/zb_users/upload/2023/06/202306131686617233591030.jpg' : 
                  'https://randomuser.me/api/portraits/men/32.jpg'
                }
                icon={<UserOutlined />}
              />
              <Text type="secondary">{post.author}</Text>
            </div>
          )}
          
          <Space className="post-stats">
            <span className="stat-item">
              <CalendarOutlined />
              {formatDate(post.date)}
            </span>
            <span className="stat-item">
              <EyeOutlined />
              {post.readCount}
            </span>
            <span className="stat-item">
              <LikeOutlined />
              {post.likes}
            </span>
          </Space>
        </div>
      </div>
    </Card>
  );
};

export default PostCard;